import { IconCheckmark } from './IconCheckmark'

export default IconCheckmark
